export default __webpack_public_path__ + "static/media/investor-6.b4666ca6.png";